import { forwardRef } from 'react'
import { cn } from '../utils/cn.ts'

interface DividerProps {
  className?: string
}

const Divider = forwardRef<HTMLHRElement, DividerProps>(
  ({ className }, ref) => {
    return (
      <hr
        ref={ref}
        role="separator"
        className={cn('divider', className)}
      />
    )
  },
)

Divider.displayName = 'Divider'

export { Divider }
export type { DividerProps }
